/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Meta, Meta$inboundSchema } from "./meta.js";
import { Pagination, Pagination$inboundSchema } from "./pagination.js";
import { Project, Project$inboundSchema } from "./project.js";

export type V1ProjectsListProjectsResponseBody = {
  /**
   * Metadata object included in every API response. This provides context about the request and is essential for debugging, audit trails, and support inquiries. The `requestId` is particularly important when troubleshooting issues with the Teral support team.
   */
  meta: Meta;
  /**
   * Array of projects in the workspace, ordered by project id.
   */
  data: Array<Project>;
  /**
   * Pagination metadata for list endpoints. Provides information necessary to traverse through large result sets efficiently using cursor-based pagination.
   */
  pagination: Pagination;
};

/** @internal */
export const V1ProjectsListProjectsResponseBody$inboundSchema: z.ZodType<
  V1ProjectsListProjectsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: z.array(Project$inboundSchema),
  pagination: Pagination$inboundSchema,
});

export function v1ProjectsListProjectsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<V1ProjectsListProjectsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      V1ProjectsListProjectsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1ProjectsListProjectsResponseBody' from JSON`,
  );
}
